
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ThresholdSlider from '~/components/Device/Threshold/ThresholdSlider.vue';
import { Device, VisionRecognitionSensitivity } from '~/interfaces/device.interface';
import apiService from '~/services/api.service';
import { NotificationsModule } from '~common/store/modules/notifications';

@Component({
    components: { ThresholdSlider },
})
export default class VisionRecognitionConfig extends Vue {
    @Prop() device!: Device;

    thresholds: Record<string, VisionRecognitionSensitivity> = {};

    get faceMaybeThreshold() {
        return this.thresholds.vision_recognition_sensitivity.face_maybe;
    }

    set faceMaybeThreshold(value) {
        this.thresholds.vision_recognition_sensitivity.face_maybe = value;
    }

    get faceKnownThreshold() {
        return this.thresholds.vision_recognition_sensitivity.face_known;
    }

    set faceKnownThreshold(value) {
        this.thresholds.vision_recognition_sensitivity.face_known = value;
    }

    @Watch('device')
    async fetchThresholds() {
        try {
            const response = (await apiService.getvpndeviceconfigs({
                device_id: this.device.id,
            })).data.body;
            if (response?.id && !response.vision_recognition_sensitivity) {
                response.vision_recognition_sensitivity = {
                    face_maybe: 3,
                    face_known: 3,
                };
            }
            this.thresholds = response;
        } catch (e) {
            NotificationsModule.pushNotification({
                type: 'error',
                title: 'Error while getting config for this device',
                duration: 5000,
            });
        }
    }

    async saveNewThresholds() {
        try {
            const body = {
                device_id: this.device.id,
                config: {
                    vision_recognition_sensitivity: this.thresholds.vision_recognition_sensitivity,
                },
            };
            await apiService.setvpndeviceconfigs(body);
            NotificationsModule.pushNotification({
                type: 'success',
                title: 'Thresholds saved successfully',
                duration: 5000,
            });
        } catch (e) {
            NotificationsModule.pushNotification({
                type: 'error',
                title: 'Error while saving new thresholds',
                duration: 5000,
            });
        }
    }

    mounted() {
        this.fetchThresholds();
    }
}
